<script>
  import './style.scss';
  import template from './template.html';
  import { EventBus } from '../../../event-bus';
  import {
    InformationOutlineIcon,
    TrashCanOutlineIcon,
    PlusIcon,
    LockIcon,
    CloseIcon,
    ChevronDownIcon
  } from '../../icons.js';
  import { getterSetterOrderDetailsValue } from '../Order-Details/getter-setter';
  import {mapState, mapActions, mapGetters} from 'vuex';
  import {isEmpty} from 'lodash';

  export default {
    template,

    props: {

      order: Object,

      userId: {
        type: [String, Number],
        required: true
      },

      selectLanguageOptionsUrl: {
        type: String,
        default: '/create-order/select-languages/options'
      },

      saveLangaugeSetUrl: {
        type: String,
        default: '/languages/sets/store',
      },

      /**
       * @note /languages/sets/delete/${languageSetId}
       */
      deleteLanguageSetUrl: {
        type: String,
        default: '/languages/sets/delete/'
      }
    },

    watch: {

      order (order) {
        //get all available source languages
        this.getSourceLanguages().then(async (sourceLanguages) => {
          let source_language = order.languages.source;
          let isValidSoureLanguage = !isEmpty(sourceLanguages.find(source => source.id == source_language));

          if (!source_language || !isValidSoureLanguage) {
            //fetch default source language
            source_language = await this.getSelectLanguagesOptions().then(options => options.source_language);
          }

          if (!isValidSoureLanguage) console.error('the source language is invalid');

          if(this.isEmptyProgram) {
            if (order.languages.target.length === 0 || isEmpty(order.details.name)) {
              order.languages.target.length = 0;
              this.target_languages = [];
              let target_language = await this.getSelectLanguagesOptions().then(options => options.target_language);
              order.languages.target.push(target_language);
            }
          }

          //update the source language
          this.updateSource(source_language).then(() => {
            this.$nextTick(() => {
              //set order target languages if any
              order.languages.target.forEach(langId => {
                let language = this.userLanguages.find(ul => ul.id == langId);

                if (language && !this.target_languages.some(tl => tl.id === language.id)) {
                  this.target_languages.push(language);
                }
              });
            })
          });
          this.fetchAccountDetails(this.coStore.onBehalf.behalf_account);
        });
      }
    },

    computed: {

      ...mapState({
        coStore: state => state.CreateOrderStore,
      }),

      ...mapState({
        source_language: state => state.CreateOrderStore.selectLanguages.source_language,
      }),

      ...mapGetters('CreateOrderStore', [
        'userLanguageSets',
        'onBehalf',
        'userLanguages',
        'accountLanguageSets',
        'sourceLanguages',
      ]),

      program: getterSetterOrderDetailsValue('program'),

      /**
      * Check if the user has set a program
      *
      * @return Boolean
      */
      isEmptyProgram() {
        return isEmpty(this.program);
      },
      
      /**
       * getter/setter for target languages
       *
       */
      target_languages: {
        get () {
          return this.coStore.selectLanguages.target_languages;
        },

        set (value) {
          this.updateTargetLanguages(value)
        }
      },

      /**
       * Get source language object
       *
       * @return Object {code, description, id, tgt}
       */
      sourceLanguage () {
        if (!this.sourceLanguages.length || !this.source_language) return {};
        return this.sourceLanguages.find(lang => lang.id == this.source_language) || {};
      },

      /**
       * Check if user has seleted any target languages
       *
       * @return Boolean
       */
      hasLanguageSet () {
        return this.target_languages.length > 0;
      },

      /**
       * Get an array of user langauge sets
       *
       * @return array [Object]
       */
      language_sets () {
        if (isEmpty(this.userLanguageSets)) return [];

        return this.userLanguageSets.map(langSet => {
          let { data: langIds } = langSet;

          langIds = langIds.split(',');

          let languages = this.userLanguages
            .filter(lang => langIds.includes(lang.id.toString()));

          return Object.assign({}, langSet, {languages})
        });
      },

      /**
       * Get an array of account langauge sets
       *
       * @return array [Object]
       */
      account_language_sets () {
        if (isEmpty(this.accountLanguageSets)) return [];

        return this.accountLanguageSets.map(langSet => {
          let { data: langIds } = langSet;

          langIds = langIds.split(',');

          let languages = this.userLanguages
            .filter(lang => langIds.includes(lang.id.toString()));

          return Object.assign({}, langSet, {languages})
        });
      },
    },

    methods: {

      ...mapActions('CreateOrderStore', [
        'updateSourceLanguage',
        'updateSourceLanguageDescription',
        'updateTargetLanguages',
        'getUserLanguageSets',
        'getAccountLanguageSets',
        'getTargetLanguages',
        'getSourceLanguages',
      ]),

      /**
       * Get Select Lanugages Options
       *
       */
      getSelectLanguagesOptions () {
        return axios
          .get(this.selectLanguageOptionsUrl)
          .then((result) => result.data)
      },

      /**
       * Check if this languageset has been deleted
       *
       */
      isDeletedSet (id) {
        return isEmpty(this.deletedLanguageSets[id]) === false;
      },

      /**
       * Add langauges to target languages
       *
       */
      addLanguages (languageSet) {
        let languageResult = this.target_languages;
        let alreadySelectedCount = 0;

        languageSet.forEach((language) => {
          let alreadySelected = this.target_languages.find(obj => obj.code == language.code);

          if (!alreadySelected) {
            this.target_languages.push(language);
          } else {
            alreadySelectedCount++;
          }
        })

        //check if all the target languages have already been added
        if (alreadySelectedCount == languageSet.length) {
          this.targetLanguageError = 'Selected target language(s) already added.';

          //clear error
          setTimeout(() => {
            this.targetLanguageError = '';
          }, 2000)
        }
      },

      /**
       * Get language sets
       *
       */
      loadLanguageSets () {
        let accountId = this.coStore.onBehalf.behalf_account;
        let behalfUserId = this.coStore.onBehalf.behalf_user;
        let { id } = this.account;
        let currentAccountId = accountId || id;
        let userId = behalfUserId || this.userId;

        let getUserLanguageSets = this.getUserLanguageSets(userId).then(result => {
          //empty deleted language sets
          this.deletedLanguageSets = {};

          return result;
        })

        let getAccountLanguageSets = this.getAccountLanguageSets(currentAccountId);


        return Promise.all([getUserLanguageSets, getAccountLanguageSets]);
      },

      /**
       * Fetch account details based on accountId
       */
      fetchAccountDetails(accountId) {

        if (accountId) {
          axios.get(`/account/${accountId}`)
            .then(response => {
              this.account = response.data.data;
            })
            .catch(error => {
              console.error('Error fetching account details:', error);
            });
        }
      },

      /**
       * Delete Language Set
       *
       */
      deleteLanguageSet (languageSet) {
        let data = {
          target_language_ids: languageSet.languages.map(s => s.id),
          source_language_id: this.source_language,
          name: languageSet.name
        }

        return axios
          .delete(this.deleteLanguageSetUrl + languageSet.id)
          .then(() => {
            //set the language set to deleted
            this.$set(this.deletedLanguageSets, languageSet.id, languageSet);

            //remove language set permanently in 5 seconds
            let timeout = setTimeout(() => {
              //check if this should still be deleted ( user hasn't undone it )
              if (this.isDeletedSet(languageSet.id)) {
                this.removeLanguageSet(languageSet.id);
              }
            }, 5000)

            //add timeout to timeouts object
            //so we can clear it later if a user clicks undo
            this.$set(this.timeouts, languageSet.id, timeout);
          });
      },

      /**
       * undo deletion of language set
       *
       */
      undoDeleteLanguageSet (id) {
        let languageSet = this.deletedLanguageSets[id];

        //re-save the deleted language set
        return this.saveLanguageSet({
          target_language_ids: languageSet.languages.map(s => s.id),
          source_language_id: this.source_language,
          name: languageSet.name
        }).then(() => {

          //remove languageSet from deleted set
          this.$set(this.deletedLanguageSets, languageSet.id, undefined);

          //clear timeout
          if (this.timeouts[languageSet.id]) {
            clearTimeout(this.timeouts[languageSet.id]);

            this.$delete(this.timeouts, languageSet.id);
          }

          //load language set
          //this.loadLanguageSets()
        });
      },

      /**
       * permanently remove language set from list of language sets
       *
       */
      removeLanguageSet (id) {
        let indx = this.language_sets.findIndex(languageSet => languageSet.id == id);

        //delete langauge set and let Vue know
        this.$delete(this.language_sets, indx);

        //remove languageSet from deleted set
        this.$set(this.deletedLanguageSets, id, undefined);
      },

      /**
       * Clear All Target Languages
       *
       */
      clearTargetLanguages () {
        this.target_languages = [];
      },

      /**
       * close language set Modal
       *
       */
      closeLanguageSetModal () {
        this.$modal.hide('language_set_modal');
        this.languageSetName = '';
      },

      /**
       * Save users langauge set
       *
       */
      saveLanguageSet (languageSet) {
        let behalfUserId = this.coStore.onBehalf.behalf_user;
        let userId = behalfUserId || this.userId;
        let data = Object.assign({ user_id: parseInt(userId) }, languageSet)

        return axios({
          method: 'post',
          url: this.saveLangaugeSetUrl,
          data
        }).then(result => {
          this.closeLanguageSetModal();
        });
      },

      /**
       * Set modals 'language set name' from user input
       *
       */
      setLanguageSetName ($event) {
        this.languageSetName = $event.target.value;

        let nameTaken = this.language_sets.find(lang => lang.name.toLowerCase() == this.languageSetName.toLowerCase())

        this.languageSetError = nameTaken ? true : false;
      },

      /**
       * update source language
       * and language sets
       *
       */
      updateSource (sourceLanguageId) {
        const prevSourceLangId = this.source_language;

        this.updateSourceLanguage(sourceLanguageId);
        this.updateSourceLanguageDescription(this.sourceLanguage.description);

        return new Promise((resolve, reject) => {
          this.getTargetLanguages().then(languages => {
            this.loadLanguageSets()

            if (prevSourceLangId !== sourceLanguageId) {
              this.clearTargetLanguages();
            }

            resolve();
          });
        });
      },

      /**
       * show dialog to save a new language set
       *
       */
      confirmSaveLanguageSet () {
        this.$modal.show({
          name: 'language_set_modal',

          template: `
            <section class="create-order-modal">
              <header class="co-modal-header">
                <h1>Add Language Set</h1>
              </header>
              <div class="co-modal-content">
                <p>Please name your new Language set</p>
                <input id="language-set-name" :maxlength="100" placeholder="Enter Language Set Name..." name="language_set_name" @input="updateName" />
                <span v-if="hasError()" class="co-modal-error">Duplicate Language Set name</span>
              </div>
              <div class="co-modal-footer two-btns">
                <button @click="save()" :disabled="isDisabled()" class="popup-confirm-btn btn-primary">Ok</button>
                <button @click="cancel()" class="popup-cancel-btn btn-secondary co-cancel-btn"">Cancel</button>
              </div>
            </section>`

          ,props: ['updateName', 'isDisabled', 'save', 'cancel', 'hasError']
        },{

          /**
           * Set modals 'language set name' from user input
           *
           */
          updateName: this.setLanguageSetName,

          hasError: () => {
            return this.languageSetError;
          },

          save: () => {
            let target_language_ids = this.target_languages.map(t => t.id);

            if (this.languageSetError) return console.error('language taken');

            this.saveLanguageSet({
              target_language_ids,
              source_language_id: this.source_language,
              name: this.languageSetName
            }).then(() => this.loadLanguageSets())
          },
          cancel: this.closeLanguageSetModal,
          isDisabled: () => this.languageSetName.length < 2 || this.languageSetError
        },{
          width: 450,
          height: 200,
          name: 'language_set_modal'
        });
      },
    },

    data () {

      let selected = Object.assign({}, this.selected);

      return {
        account: window.backend.account,
        isVisible: false,
        showAllLanguages: false,
        languageSetError: false,
        languageSetName: '',
        targetLanguageError: '',
        selectedItem: selected,
        deletedLanguageSets: {},
        timeouts: {},
      }
    },

    components: {
      InformationOutlineIcon,
      TrashCanOutlineIcon,
      PlusIcon,
      LockIcon,
      CloseIcon,
      ChevronDownIcon,
    },

    directives: {}
  }
</script>
